import { useState, useEffect } from 'react'
import './App.css'
import { Routes, Route, useLocation } from 'react-router-dom'
import { Home } from './main/home/home'
import { Head } from './main/head/head'
import { ThemeProvider, responsiveFontSizes } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import theme from './theme'
import { Groups } from './main/pages/groups'
import { About } from './main/pages/about'
import { Terms } from './main/pages/terms'
import { Faq } from './main/pages/faq'
import { History } from './main/pages/history'
import { Contest, ContestDetails } from './main/pages/contest'
import { Demos } from './main/pages/demos'
import { Sponsors } from './main/pages/sponsors'
import { Standards } from './main/pages/standards'
import { Join as JoinEventNotifications } from './main/pages/join'
import { Stop as StopEventNotifications } from './main/pages/stop'

const App = ({}) => {
  const location = useLocation()
  let [user, setUser] = useState(null)
  useEffect(() => {}, [])

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes location={location} key={location.pathname}>
          <Route path={'/'} element={<Head user={user} />}>
            <Route index element={<Home user={user} />} />
            <Route path={'/groups'} element={<Groups />} />
            <Route path={'/about'} element={<About />} />
            <Route path={'/more-info'} element={<Faq />} />
            <Route path={'/terms'} element={<Terms />} />
            <Route path={'/history'} element={<History />} />
            <Route path={'/demos'} element={<Demos />} />
            <Route path={'/sponsors'} element={<Sponsors />} />
            <Route path={'/standards'} element={<Standards />} />
          </Route>
          <Route path={'/join'} element={<JoinEventNotifications />} />
          <Route path={'/stop'} element={<StopEventNotifications />} />
        </Routes>
      </ThemeProvider>
    </>
  )
}

export default App
